import { MessageType } from '@/types/common';
import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';
import { Message } from '@/enums/message.enum';
import { MESSAGE } from '@/constants/message.constant';

type UnitConversionState = {
  loading: boolean;
  message?: MessageType;
  unitConversionList: UnitConversionList;
};

const initialState: UnitConversionState = {
  loading: false,
  unitConversionList: []
};

export const unitConversionSlice = createAppSlice({
  name: 'unit-conversion',
  initialState,
  reducers: (create) => ({
    getUnitConversion: create.asyncThunk(
      async (model: string) => {
        const response = await apiFetcher.post(`change-indicator/detail`, {
          model
        });
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.unitConversionList = transformerArray(action.payload.listData);
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    ),
    updateUnitConversion: create.asyncThunk(
      async (data: { model: string; items: string }) => {
        const response = await apiFetcher.post('change-indicator', data);
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state) => {
          state.loading = false;
          state.message = {
            type: Message.SUCCESS,
            message: MESSAGE.UPDATE_SUCCESS
          };
        },
        rejected: (state) => {
          state.loading = false;
          state.message = {
            type: Message.ERROR,
            message: MESSAGE.UPDATE_FAIL
          };
        }
      }
    ),
    resetMessages: create.reducer((state) => {
      state.message = undefined;
    })
  }),

  selectors: {
    watchUnitConversionLoading: (UnitConversion) => UnitConversion.loading,
    watchUnitConversionMessage: (UnitConversion) => UnitConversion.message,
    watchUnitConversionList: (UnitConversion) =>
      UnitConversion.unitConversionList
  }
});

export const {
  watchUnitConversionLoading,
  watchUnitConversionMessage,
  watchUnitConversionList
} = unitConversionSlice.selectors;

export const { getUnitConversion, updateUnitConversion, resetMessages } =
  unitConversionSlice.actions;
